module.exports = __webpack_public_path__ + "static/media/sub4.1ba88585.png";